import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { ProjectScenario, ProjectsScenariosRestDataProvider } from '../data/ProjectScenariosDataProvider';

interface ProjectScenariosContextType {
  scenarios: ProjectScenario[];
  setScenarios: React.Dispatch<React.SetStateAction<ProjectScenario[]>>;
  reload: () => Promise<void>;
}

const ProjectScenariosContext = createContext<ProjectScenariosContextType | undefined>(undefined);

export const useProjectScenarios = () => {
  const ctx = useContext(ProjectScenariosContext);
  if (!ctx) throw new Error('useProjectScenarios must be used within ProjectScenariosProvider');
  return ctx;
};

export const ProjectScenariosProvider: React.FC<{ projectId: string; children: ReactNode }> = ({ projectId, children }) => {
  const [scenarios, setScenarios] = useState<ProjectScenario[]>([]);
  const provider = new ProjectsScenariosRestDataProvider();

  const reload = async () => {
    const all = await provider.getAll();
    setScenarios(all.filter(s => s.projectId === projectId));
  };

  useEffect(() => {
    reload();
    // eslint-disable-next-line
  }, [projectId]);

  return (
    <ProjectScenariosContext.Provider value={{ scenarios, setScenarios, reload }}>
      {children}
    </ProjectScenariosContext.Provider>
  );
};
